import { GetFeatureUsagesResponsePermissionResource } from '@modusign/openapi-client-subscription/model';

export type AuthorityResource = GetFeatureUsagesResponsePermissionResource;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthorityResource = GetFeatureUsagesResponsePermissionResource;
